// @flow

import { connect } from 'react-redux';
import SubCategoryList from './subCategoryList';
import { getFAQCategoryListChooseACategoryText } from '../../../store/componentSettings/selectors';

type StateProps = {|
  defaultDropdownOption: string,
|};

const mapStateToProps = (state): StateProps => ({
  defaultDropdownOption: getFAQCategoryListChooseACategoryText(state),
});

export default connect<any, void, StateProps, any, any, any>(mapStateToProps)(SubCategoryList);
